type stringHash = {
  [key: string]: string;
};

export const currencyConversion = (currency: string): string => {
  const translations: stringHash = {
    GBP: '£',
    CAD: 'CAD',
    DKK: 'kr',
    USD: '$',
    EUR: '€',
    NOK: 'kr',
    HUF: 'Ft',
    CHF: 'Fr',
    MYR: 'RM',
    AED: 'د.إ',
    RMB: '¥',
  };
  return translations[currency];
};

export const scheduleConversion = (schedule: string, desktop = false): string => {
  const translations: stringHash = {
    full_time: desktop ? 'full-time' : 'full time',
    part_time: desktop ? 'part-time' : 'part time',
  };
  return translations[schedule];
};

export const costOfLivingYearly = (cost_of_living: number): string => {
  return formatNumber(cost_of_living * 12);
};

export const tuitionConversion = (tuition?: number, duration?: number): string => {
  if (tuition === undefined || duration === undefined) return '';
  return `${formatNumber(Math.round(tuition / (duration / 12)))}`;
};

export const formatNumber = (amount?: string | number): string => {
  if (amount === undefined) return '';
  return `${amount}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export const durationProgram = (duration: number | undefined): number => {
  return Math.round(duration ? duration / 12 : 0);
};

export const workExperience = (years: number | undefined): string => {
  if (years === undefined) return '';
  return years > 1 ? `${years} years of experience` : '1 year of experience';
};

export const formatDeadlineDate = (date?: Date): string => {
  if (date === undefined || date == null) return '';

  const dateFormatted = new Date(date);
  return `${formatMonth(date)} ${dateFormatted.getFullYear()}`;
};

export const formatIntakeDate = (date?: Date): string => {
  if (date === undefined || date == null) return '';

  return formatMonth(date);
};

export const formatMonth = (date?: Date, long = false): string => {
  if (date === undefined || date == null) return '';
  const monthShortNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const dateFormatted = new Date(date);
  return long ? monthNames[dateFormatted.getMonth()] : monthShortNames[dateFormatted.getMonth()];
};

export const firstUpperCase = (word?: string): string => {
  if (word === undefined) return '';
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const parameterize = (text?: string, length = 50, spaceChar = '-'): string => {
  if (text === undefined) return '';
  return text
    .trim()
    .toLowerCase()
    .replace(/[^\w\s]/g, '')
    .replace(/[-\s]+/g, spaceChar)
    .slice(0, length);
};

export const detailUrl = (path: string, id?: number, name?: string, spv?: boolean) =>
  `/explore/${path}/${id}--${parameterize(name)}${spv ? '&spv=1' : ''}`;

export const newDetailUrl = (path: string, id?: number, name?: string, spv?: boolean) =>
  `/${path}/${id}--${parameterize(name)}${spv ? '&spv=1' : ''}`;
